import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import { Routes } from 'routing';

import EditProduct from 'views/Product/EditProduct/index';
import CreateProduct from 'views/Product/CreateProduct/index';

const ProductRouter = () => {
	return (
		<Switch>
			<Route exact path={Routes.CATALOG_CREATE_PRODUCT} component={CreateProduct} />
			<Route path={Routes.CATALOG_PRODUCT_TAB} component={EditProduct} />
			<Route path={Routes.CATALOG_PRODUCT} component={EditProduct} />
			<Route
				path={Routes.CATALOG_PRODUCT}
				render={({ match }) => <Redirect to={Routes.ProductPage(match.params.productId)} />}
			/>
			<Redirect to={Routes.CATALOG} />
		</Switch>
	);
};

export default ProductRouter;
